import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Rocket, Users, Heart } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center pt-24 pb-16 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-white to-slate-50" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,rgba(142,227,205,0.2)_0%,rgba(255,255,255,0)_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_80%,rgba(155,135,245,0.15)_0%,rgba(255,255,255,0)_60%)]" />
      
      {/* Animated dots pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(#2b825b 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }} />

      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
                Passionnés par la <span className="text-orcsys-500">création</span> de solutions numériques
              </h1>
              
              <p className="text-lg text-slate-600 mb-8">
                Nous sommes une équipe d'ingénieurs et de créatifs dédiés à transformer les visions audacieuses 
                en réalités numériques. Notre mission : accompagner les entrepreneurs passionnés 
                dans leur réussite.
              </p>

              <div className="grid grid-cols-2 gap-6">
                {[
                  {
                    icon: <Code2 className="w-6 h-6 text-orcsys-500" />,
                    label: "Expertise technique",
                    value: "5+ ans"
                  },
                  {
                    icon: <Rocket className="w-6 h-6 text-orcsys-500" />,
                    label: "Projets lancés",
                    value: "25+"
                  },
                  {
                    icon: <Users className="w-6 h-6 text-orcsys-500" />,
                    label: "Startups accompagnées",
                    value: "15+"
                  },
                  {
                    icon: <Heart className="w-6 h-6 text-orcsys-500" />,
                    label: "Satisfaction client",
                    value: "98%"
                  }
                ].map((stat, index) => (
                  <motion.div
                    key={index}
                    className="bg-white rounded-xl p-4 shadow-lg border border-slate-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
                  >
                    <div className="flex items-center space-x-3 mb-2">
                      {stat.icon}
                      <span className="text-slate-600 font-medium">{stat.label}</span>
                    </div>
                    <div className="text-2xl font-bold text-slate-900">{stat.value}</div>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="relative"
            >
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-br from-orcsys-500/90 to-orcsys-600/90 mix-blend-multiply" />
                <img 
                  src="https://images.unsplash.com/photo-1553877522-43269d4ea984?q=80&w=2070&auto=format&fit=crop" 
                  alt="Notre équipe au travail" 
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center text-white">
                    <div className="w-20 h-20 rounded-full bg-white/10 backdrop-blur-sm mx-auto mb-4 flex items-center justify-center">
                      <Code2 className="w-10 h-10" />
                    </div>
                    <h3 className="text-2xl font-bold mb-2">Notre Objectif</h3>
                    <p className="text-white/90 max-w-md mx-auto px-6">
                      Créer des solutions technologiques qui permettent 
                      aux entrepreneurs de concrétiser leurs vision.
                    </p>
                  </div>
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-10 -left-10 w-40 h-40 bg-orcsys-500/10 rounded-full blur-3xl" />
              <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-orcsys-500/10 rounded-full blur-3xl" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 